import type { Nullable } from '../../types/common'
import BaseComponent from '../base-component/base-component'
import type Cart from './cart'
import type CartDrawer from './cart-drawer'

class CartNote extends BaseComponent {
  textareaAttribute: string
  localStorageSelector: string
  cartSelector: string
  cartDrawerSelector: string

  cart: Nullable<Cart>
  cartDrawer: Nullable<CartDrawer>

  textarea: Nullable<HTMLTextAreaElement>
  valueFromLS: string | null
  currentValue: string | undefined

  constructor() {
    super()

    this.textareaAttribute = 'data-cart-note-textarea'
    this.localStorageSelector = 'cartNote'
    this.cartSelector = 'cart-page'
    this.cartDrawerSelector = 'cart-drawer'

    this.cart = this.closest(this.cartSelector)
    this.cartDrawer = this.closest(this.cartDrawerSelector)

    this.textarea = this.querySelector(`[${this.textareaAttribute}]`)
    this.currentValue = this.textarea?.value
  }

  connectedCallback(): void {
    this.setValueFromLS()

    this.textarea?.addEventListener('blur', this.handleTextareaBlur)
    window.addEventListener('storage', this.handleBetweenTabsUpdate)

    customElements
      .whenDefined(this.cartSelector)
      .then(() =>
        this.cart?.subscribe('cartIsEmpty', this.handleCartStatusUpdate),
      )
      .catch(err => {
        console.log(err)
      })

    customElements
      .whenDefined(this.cartDrawerSelector)
      .then(() =>
        this.cartDrawer?.subscribe('cartIsEmpty', this.handleCartStatusUpdate),
      )
      .catch(err => {
        console.log(err)
      })
  }

  disconnectedCallback(): void {
    this.textarea?.removeEventListener('blur', this.handleTextareaBlur)
    window.removeEventListener('storage', this.handleBetweenTabsUpdate)

    this.cart?.unsubscribe('cartIsEmpty', this.handleCartStatusUpdate)
    this.cartDrawer?.unsubscribe('cartIsEmpty', this.handleCartStatusUpdate)
  }

  handleTextareaBlur = (e: FocusEvent): void => {
    const { value } = e.target

    if (!value) {
      return
    }

    localStorage.setItem(this.localStorageSelector, value)
    this.currentValue = value
  }

  setValueFromLS = (): void => {
    this.valueFromLS = localStorage.getItem(this.localStorageSelector)

    if (this.valueFromLS !== this.currentValue) {
      this.textarea.value = this.valueFromLS
      this.currentValue = this.valueFromLS
    }
  }

  handleBetweenTabsUpdate = (e: StorageEvent): void => {
    if (e.key === this.localStorageSelector) {
      this.setValueFromLS()
    }
  }

  handleCartStatusUpdate = (): void => {
    this.clearValueFromLS()
  }

  clearValueFromLS = (): void => {
    localStorage.removeItem(this.localStorageSelector)
    this.currentValue = undefined
  }
}

export default CartNote
